"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.filter");

require("core-js/modules/es.object.get-own-property-descriptor");

require("core-js/modules/es.object.keys");

require("core-js/modules/es.parse-int");

require("core-js/modules/es.string.replace");

require("core-js/modules/es.string.search");

require("core-js/modules/web.dom-collections.for-each");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.recordImpression = recordImpression;
exports.recordEvent = recordEvent;
Object.defineProperty(exports, "queryString", {
  enumerable: true,
  get: function get() {
    return _queryString2.default;
  }
});
exports.default = void 0;

var _sendBeacon = _interopRequireDefault(require("./sendBeacon"));

var _queryString2 = _interopRequireDefault(require("./queryString"));

var _main = require("./main");

var _v = _interopRequireDefault(require("uuid/v1"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function recordImpression(window, url, country, page) {
  if (!window.pac_analytics) {
    var rockmanId = (0, _v.default)().replace(/-/g, "");
    var campaignId = parseInt((0, _queryString2.default)(window.location.search, "cid")) || 2;
    window.pac_analytics = {
      visitor: {
        rockmanId: rockmanId,
        impressionNumber: 1,
        //TODO: get impressionNumber from localStorage
        country: country,
        page: page,
        xaid: (0, _queryString2.default)(window.location.search, "xaid"),
        cid: campaignId,
        offer: parseInt((0, _queryString2.default)(window.location.search, "offer")) || 1 // default to 1 offer id

      },
      startTime: new Date().valueOf(),
      queryString: function queryString(key) {
        return (0, _queryString2.default)(window.location.search, key);
      },
      url: url,
      userId: rockmanId,
      encCampaignId: (0, _queryString2.default)(window.location.search, "xcid"),
      originalUrl: document.location.href
    };
    var sendBeacon = (0, _sendBeacon.default)(window);
    sendBeacon("".concat(url, "/impression/").concat(window.pac_analytics.encCampaignId), {
      rockmanId: window.pac_analytics.visitor.rockmanId,
      userId: window.pac_analytics.userId,
      page: window.pac_analytics.visitor.page,
      originalUrl: window.pac_analytics.originalUrl
    });
  } else {
    console.info("No need to record an impression from client");

    window.pac_analytics.queryString = function (key) {
      return (0, _queryString2.default)(window.location.search, key);
    };
  } // expect that window.pac_analytics[.visitor] is ready


  window.pacman = new _main.Pacman(window, window.pac_analytics.visitor, window.pac_analytics.startTime);
  window.pacman.initInteractions();
  window.pacman.sendPageview();

  if (!window.dataLayer) {
    window.dataLayer = window.dataLayer || [];
  }

  window.dataLayer.push({
    affiliate_id: window.pac_analytics.visitor.xaid
  });
  return window.pac_analytics;
}

function recordEvent(window, url, view, flowEvent) {
  var sendBeacon = (0, _sendBeacon.default)(window);

  if (!window.pac_analytics) {
    throw Error("Please call recordImpression() first. 'pac_analytics' was not found.");
  }

  var eventDetail = _objectSpread({
    rockmanId: window.pac_analytics.visitor.rockmanId,
    relt: new Date().valueOf() - window.pac_analytics.startTime,
    view: view
  }, flowEvent);

  sendBeacon("".concat(url, "/event"), eventDetail);

  try {
    window.pacman.sendFlowEvent(flowEvent);
  } catch (err) {
    console.warn(err);
  }

  try {
    var ev = new CustomEvent('tracking-event', {
      detail: eventDetail
    });
    document.body.dispatchEvent(ev);
  } catch (ex) {
    console.warn(ex);
  }
}

var _default = function _default(window, country, page) {
  if (!window) {
    return {
      viewChanged: function viewChanged() {
        return void 6;
      },
      msisdnSubmitted: function msisdnSubmitted() {
        return void 6;
      },
      advancedInFlow: function advancedInFlow() {
        return void 6;
      },
      advancedInPreFlow: function advancedInPreFlow() {
        return void 6;
      },
      recedeInFlow: function recedeInFlow() {
        return void 6;
      },
      customEvent: function customEvent() {
        return void 6;
      }
    };
  } else {
    var current_view = "Init";
    var url = !!window.pac_analytics ? window.pac_analytics.url : (0, _queryString2.default)(window.location.search, "pacman-server") || "/analytics"; // recordImpression manipulates window object by adding pac_analytics

    var pac_analytics = recordImpression(window, url, country, page);
    window.dataLayer.push({
      xaid: pac_analytics.visitor.xaid,
      country: country,
      page: page,
      offer: pac_analytics.visitor.offer
    });
    return {
      viewChanged: function viewChanged(view) {
        if (view != current_view) {
          recordEvent(window, url, view, {
            category: "UI",
            action: "ViewChanged"
          });
          current_view = view;
        }
      },
      msisdnSubmitted: function msisdnSubmitted(msisdn) {
        recordEvent(window, url, current_view, {
          category: "UX",
          action: "MSISDN-Submitted",
          args: {
            msisdn: msisdn
          }
        });
      },
      advancedInPreFlow: function advancedInPreFlow(label, args) {
        var gaEvent = {
          category: "Pre-Flow",
          action: "advance",
          label: label
        };
        recordEvent(window, url, current_view, _objectSpread({}, gaEvent, {
          args: args
        }));
        window.dataLayer.push(_objectSpread({}, gaEvent, {
          event: "gaEvent"
        })); // how to trigger a custom event on window object:
        // const event = new CustomEvent('gaEvent', { detail: {category: 'Pre-Flow'} });
        // window.dispatchEvent(event)
      },
      recedeInFlow: function recedeInFlow(flow, reason, args) {
        var gaEvent = {
          category: "Flow",
          action: "recede",
          label: "".concat(reason)
        };
        recordEvent(window, url, current_view, _objectSpread({}, gaEvent, {
          args: args
        }));
        window.dataLayer.push(_objectSpread({}, gaEvent, {
          event: "gaEvent"
        }));
      },
      advancedInFlow: function advancedInFlow(flow, action, args) {
        var gaEvent = {
          category: "Flow",
          action: "advance",
          label: "".concat(action)
        };
        recordEvent(window, url, current_view, _objectSpread({}, gaEvent, {
          args: args
        }));
        window.dataLayer.push(_objectSpread({}, gaEvent, {
          event: "gaEvent"
        }));
      },
      //Flow,   advance-auto, label : e.g indentify-success | indentify-failure, args : error | data | {}
      customEvent: function customEvent(category, action, label, args) {
        var gaEvent = {
          category: category,
          action: action,
          label: label
        };
        recordEvent(window, url, current_view, _objectSpread({}, gaEvent, {
          args: args
        }));
        window.dataLayer.push(_objectSpread({}, gaEvent, {
          event: "gaEvent"
        }));
      }
    };
  }
};

exports.default = _default;